import React from 'react'
import serverData from 'utils/server-data'

// eslint-disable-next-line camelcase
export default function Layout(props) {
  const directionality = serverData.locality.directionality

  return (
    <div style={{ direction: directionality }}>
      <>{props.children}</>
    </div>
  )
}
